var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0966 10.9094C16.9299 11.3905 16.9299 12.5933 16.0966 13.0744L10.3052 16.4181C9.47184 16.8992 8.43018 16.2978 8.43018 15.3356V8.64821C8.43018 7.68596 9.47184 7.08455 10.3052 7.56567L16.0966 10.9094Z",
    fill: "#5E6C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9467 4.03768C17.9108 2.00176 15.0981 0.742188 11.9922 0.742188C8.88626 0.742188 6.07361 2.00176 4.03768 4.03768C2.00176 6.07361 0.742188 8.88626 0.742188 11.9922C0.742188 15.0981 2.00176 17.9108 4.03768 19.9467C6.07361 21.9826 8.88626 23.2422 11.9922 23.2422C15.0981 23.2422 17.9108 21.9826 19.9467 19.9467C21.9826 17.9108 23.2422 15.0981 23.2422 11.9922C23.2422 8.88626 21.9826 6.07361 19.9467 4.03768ZM11.9922 2.61719C14.5806 2.61719 16.9245 3.66674 18.6211 5.36332C20.3176 7.0599 21.3672 9.4038 21.3672 11.9922C21.3672 14.5806 20.3176 16.9245 18.6211 18.6211C16.9245 20.3176 14.5806 21.3672 11.9922 21.3672C9.4038 21.3672 7.0599 20.3176 5.36332 18.6211C3.66674 16.9245 2.61719 14.5806 2.61719 11.9922C2.61719 9.4038 3.66674 7.0599 5.36332 5.36332C7.0599 3.66674 9.4038 2.61719 11.9922 2.61719Z",
    fill: "#5E6C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.6c113f8eff4d0184e6e1fcd61f720dde.svg";
export { ForwardRef as ReactComponent };